// extracted by mini-css-extract-plugin
export var speaker = "style-module--speaker--27ba7";
export var speakerTitle = "style-module--speaker-title--e6f15";
export var speaker_inner = "style-module--speaker_inner--a814f";
export var speaker_innerCol = "style-module--speaker_inner-col--c1d3f";
export var speaker_innerCol_list = "style-module--speaker_inner-col_list--66c05";
export var speaker_innerCol_listStr = "style-module--speaker_inner-col_list-str--7a4ce";
export var speaker_innerCol_photo = "style-module--speaker_inner-col_photo--282fe";
export var speaker_innerCol_title = "style-module--speaker_inner-col_title--8c742";